import { IOffer } from '../../types/offers';

export const OFFERS_LIMIT = 6;
export const OFFER_TEMPLATE: IOffer = {
  id: 0,
  photoUrl: '',
  price: '',
  features: [],
  url: '',
  underground: null,
};
